module.exports = __webpack_public_path__ + "assets/icons/ic_content_copy_24px.svg";